// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"32bd553f","84":"9349a11b","149":"521cdb7e","244":"afc543ef","275":"266b3d15","407":"425327af","426":"c0294a95","667":"8b83a348","919":"d552e8f5","990":"2c4bd24b"}[chunkId] + ".chunk.js";
};